export const IsotopeConstants = {
  COLUMN_WIDTH: '.widget-grid-sizer',
  DATA_SET_IDENTIFIER: 'data-grid-item',
  DEFAULT_WIDTH: 1362,
  ITEM_SELECTOR: '.grid-item',
  LAYOUT_MODE: 'masonry',
  SCROLL_SMOOTH: 'smooth',
  SCROLL_INSTANT: 'instant',
  SORT_BY: 'displayOrder',
  TRANSITION_DURATION: '0.1s',
  DISPLAY_ORDER_TIMEOUT: 250,
};
